<mat-icon style="float: right; cursor: pointer" (click)="close()">clear</mat-icon>

<soillib-surveys-import-ags
  [level]="'jobsite'"
  [isSBT]="isSBT"
  (finishAgsImportEvent)="finishAgsImport($event)"
  [currentJobsite]="data.currentJobsite"
></soillib-surveys-import-ags>
